import type { BoPhan, BoPhanSuDungCCDC } from '@/types/schemas';
import type { DataTableColumn } from '@/components/custom/erp';

export const getDataTableColumns = (): DataTableColumn<BoPhanSuDungCCDC>[] => [
  {
    field: 'ma_bp',
    headerName: 'Mã bộ phận',
    width: 200
  },
  {
    field: 'ten_bp',
    headerName: 'Tên bộ phận',
    width: 300
  }
];

export const feeColumns: DataTableColumn<BoPhan>[] = [
  {
    field: 'ma_bp',
    headerName: 'Mã bộ phận phí',
    width: 120
  },
  {
    field: 'ten_bp',
    headerName: 'Tên bộ phận phí',
    width: 200
  }
];
